/* eslint-disable jsx-a11y/anchor-is-valid */
import TireSeasonIcon from "component/design-system/badge/TireSeasonIcon";
import { VEHICLE_FITMENT } from "constant/shared-constants";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import HideIf from "util/HideIf";
import { getProductHeading } from "../../util/product/get-product-heading";
import { isKit } from "../../util/product/is-kit";
import ExtendedDescription from "./extended-definition/ExtendedDescription";
import MultipleFilterableAttributes from "./extended-definition/MultipleFilterableAttributes";
import WheelTireExtendedDescription from "./extended-definition/WheelTireExtendedDescription";
import { getSeason } from "./product-container-util";
import styles from "./product-item-detailed/product-item-detailed.module.scss";

const ProductExtendedDescription = dynamic(() => import(/* webpackChunkName: "product-extended-description" */ "modules/extended-desciption/ProductExtendedDescription"));

export default function ProducItemDetailedCommon({
  showMore,
  product,
  showTopSeparator,
  accordionColor,
  accordionHeight,
  sliceInfo,
  extendedInfoKeys = [],
  gridView = false,
  showTireSeasonIcon = true,
}: any) {
  const { t } = useTranslation(["category", "category-map", "common"]);
  const catMapT = (_: string) => t(_, { ns: "category-map" });

  const { extendedDescription } = product;
  const season = getSeason(product);

  if (product.fitment === VEHICLE_FITMENT.UNIVERSAL) {
    return (
      <ProductExtendedDescription
        data={product.extendedDescription.descriptions}
        showMore={showMore}
        style={{ display: "inline-grid" }}
      />
    );
  }

  // is tire Product
  if (["Tire", "Wheel", catMapT("Tire"), catMapT("Wheel")].includes(product.description) && !gridView) {
    return (
      <>
        <MultipleFilterableAttributes filterableAttributes={product.filterableAttributes} iconSize={20} />
        <WheelTireExtendedDescription
          filterableAttributes={product.filterableAttributes}
          extendedDescription={product.productSpecifications}
          gridView={gridView}
          season={season}
          maxKeys={extendedInfoKeys.length || (["wheel", catMapT("Wheel")].includes(product.description)) ? 4 : 2}
          extendedInfoKeys={extendedInfoKeys}
          iconSize={25}
        />
      </>
    );
  }

  if (isKit(product) && ["Wheel & Tire Packages", catMapT("Wheel & Tire Packages")].includes(product.description)) {
    return (
      <>
        <div className={styles.kit_extended_description}>
          {
            extendedDescription.components.map((component: any, idx: any) => (
              <ExtendedDescription
                extendedDescription={component.extendedDescription}
                showTopSeparator={showTopSeparator}
                description={getProductHeading(component)}
                specClassName={styles.white_space}
                tier3={product.enCategory.tier3}
                quantity={component.quantity}
                key={idx}
                accordionColor={accordionColor}
                accordionHeight={accordionHeight}
                sliceInfo={sliceInfo}
              />
            ))
          }
        </div>
        <HideIf show={showTireSeasonIcon}>
          <TireSeasonIcon
            row
            style={{ padding: "calc(0.5 * var(--safari-root-font, 10px)) calc(0.5 * var(--safari-root-font, 10px)) 0 0" }}
            season={season}
            width={20}
            height={20}
            color="black"
          />
        </HideIf>

      </>
    );
  }
  return null;
}
